import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const DialogContainer = styled(FlexContainer)({
  padding: "20px",
})
